import { createReducer, on } from '@ngrx/store';

export const initialState = null;
import { loadConfirmationNumber } from '../_actions/confirmation.actions';


const _confirmationNumberReducer = createReducer(initialState,
    on(loadConfirmationNumber, (state, payload) => {
        console.log('Confirmation Number', state, payload)
        console.log('Confirmation Reducer - Contracts in payload:', payload.contracts);
        console.log('Confirmation Reducer - Full payload being stored:', payload);
        sessionStorage.setItem('confirmationNumber', JSON.stringify(payload))
        return payload;
    })
);

export function confirmationNumberReducer(state, action) {
    return _confirmationNumberReducer(state, action);
}